import React from 'react';

import { FormModal } from 'modules/layer00';
import { ReturnAuthorizationSummarySection } from 'modules/layer01';
import { Button } from '@mui/material';
import * as dataService from './dataService';



export interface IProps {
  returnAuthorizationId: string;
  storeId?: string;

  onClose: () => void;
  onUpdateApprovalStatus: () => void;
}

export const FC: React.FC<IProps> = props => {
  const [
    approveReturn,
    approveReturnTuple
  ] = dataService.useApproveReturnAuthorization(props.returnAuthorizationId, props.storeId);



  const handleClickApproveReturn = React.useCallback(
    async () => {
      if (window.confirm("Are you sure you want to approve this return?")) {
        await approveReturn('approved');
        props.onUpdateApprovalStatus();
        props.onClose();
      }
    },
    [
      approveReturn,
      props
    ]
  );

  const handleClickDenyReturn = React.useCallback(
    async () => {
      if (window.confirm("Are you sure you want to deny this return?")) {
        await approveReturn('denied');
        props.onUpdateApprovalStatus();
      }
    },
    [
      approveReturn,
      props
    ]
  );



  const loading = approveReturnTuple.loading;

  return (
    <FormModal.FC
      isDoubleWide
      title="Approve Return"
      onClose={props.onClose}
      isLoading={loading}
      fnGenElCloseButton={() => (
        <Button
          variant="contained"
          size="large"
          color="error"
          disabled={loading}
          onClick={handleClickDenyReturn}>
          Deny
        </Button>
      )}
      fnGenElAcceptButton={() => (
        <Button
          variant="contained"
          size="large"
          color="primary"
          disabled={loading}
          onClick={handleClickApproveReturn}>
          Approve
        </Button>
      )}>
      <ReturnAuthorizationSummarySection.FC returnAuthorizationId={props.returnAuthorizationId} />
    </FormModal.FC>
  );
};
